import { render, staticRenderFns } from "./DashboardChart.vue?vue&type=template&id=52e9ae7e&scoped=true&"
import script from "./DashboardChart.vue?vue&type=script&lang=ts&"
export * from "./DashboardChart.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardChart.vue?vue&type=style&index=0&id=52e9ae7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e9ae7e",
  null
  
)

export default component.exports